import getImageUrl from "./getImageUrl";

/**
 * Catalog / burger menu: prefer category photo, fall back to menu icon.
 */
export default function getCategoryMenuImg(category) {
  if (!category) return null;
  const photo =
    category?.category_image?.image ||
    category?.categoryImage?.image ||
    (typeof category?.image === "string" ? category.image : category?.image?.image) ||
    null;
  return getImageUrl(photo || category?.icon);
}
